import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

export const TAKE_UNIT_QUIZ_CONFIRM_TITLE_ID = 'take-unit-quiz-confirm-title';

@Component({
  selector: 'lp2-take-unit-quiz-confirm-modal',
  templateUrl: './take-unit-quiz-confirm-modal.component.html',
  styleUrls: ['./take-unit-quiz-confirm-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class TakeUnitQuizConfirmModalComponent {
  @Input() unitNumber: number;
  @Input() nextUnitNumber: number;

  readonly titleId = TAKE_UNIT_QUIZ_CONFIRM_TITLE_ID;

  constructor(private readonly modal: NgbActiveModal) {}

  takeQuiz() {
    this.modal.close(true);
  }

  keepLearning() {
    this.modal.dismiss();
  }
}



// WEBPACK FOOTER //
// ./ts/app/home/mini-lesson-section/take-unit-quiz/take-unit-quiz-confirm-modal.component.ts